import { createSelector } from 'reselect';
import type { IUserInfo, IUserMailbox } from '../../api/domain';
import type { IRootState } from '../root-reducer';
import { userInfoApiSelectors } from '../user-info-api';

export const getAttachments = (state: IRootState) => state.secureInboxApi.attachments;
export const getAttachmentsFileSize = (state: IRootState) => state.secureInboxApi.attachmentFileSize;
export const getSettings = (state: IRootState) => state.secureInboxApi.settings;
export const getTopics = (state: IRootState) => state.secureInboxApi.topics;
export const getMailboxes = (state: IRootState) => state.secureInboxApi.mailboxes;
export const getMessages = (state: IRootState) => state.secureInboxApi.messages;
export const getSupportedAttachmentMediaTypes = (state: IRootState) => state.secureInboxApi.settings.supportedAttachmentMediaTypes;
export const getTotalMessageCount = (state: IRootState) => state.secureInboxApi.totalCount;
export const getMessage = (state: IRootState) => state.secureInboxApi.message;
export const getUnreadMessagesCount = (state: IRootState) => state.secureInboxApi.unreadMessagesCount;
export const getOrderedMailboxes: (state: IRootState) => IUserMailbox[] = createSelector(
    getMailboxes,
    userInfoApiSelectors.getUserInfo,
    (mailboxes: IUserMailbox[], userInfo?: IUserInfo) => {
        if (!userInfo) {
            return mailboxes;
        }

        const ownMailboxes = mailboxes.filter((mb) => mb.externalIds.includes(userInfo.userId));
        const otherMailboxes = mailboxes.filter((mb) => !mb.externalIds.includes(userInfo.userId));

        return [...ownMailboxes, ...otherMailboxes];
    },
);
